export class FieldValueLookupError extends Error {}
